import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const ReactionMenu = ({ children }: { children: ReactNode }) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const chatContainer = document.getElementById('chat-container');
    if (chatContainer) {
      setContainer(chatContainer);
    }
  }, []);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
